import {createDataStore} from '@shared_web/lib/data_store';

const doorIdsStore = createDataStore<string[] | undefined>(undefined);

export const useDoorIds = doorIdsStore.useData;
export const setDoorIds = doorIdsStore.setData;
export const clearDoorIds = () => doorIdsStore.setData(undefined);
